// Version announcement plugin — logs version info for debugging and tracks
// mismatches via GTM. Does NOT trigger reloads — that's handled solely by
// PwaUpdateBanner via the service worker update lifecycle.

export default defineNuxtPlugin(async (nuxtApp) => {
  const alfredVersion = nuxtApp.$config.public.alfredVersion
  // eslint-disable-next-line no-console -- Version info for Sentry breadcrumbs
  console.warn(`Alfred version: ${alfredVersion}`)

  let version: string
  try {
    ;({ version } = await $fetch('/api/version/', {
      timeout: 10000,
    }))
  } catch {
    return
  }

  // eslint-disable-next-line no-console -- Version info for Sentry breadcrumbs
  console.warn(`Alfred server version: ${version}`)

  if (version === alfredVersion) return

  // eslint-disable-next-line no-console -- Version mismatch for Sentry breadcrumbs
  console.warn('Alfred version mismatch.', version, alfredVersion)

  // Track version mismatch event in GTM for analytics
  const { $gtm } = nuxtApp
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- GTM is untyped
  if ($gtm && typeof ($gtm as any).push === 'function') {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call -- GTM is untyped
    ;($gtm as any).push({
      event: 'version-mismatch',
      version,
      alfredVersion,
    })
  }
})
